import { fetchWithAuth } from './fetchWithAuth';
import { GmailAccountDTO } from '../../types/gmail';

export const gmailApi = {
  // Get OAuth URL
  getAuthUrl: async (orgId: string, token: string) => {
    const response = await fetchWithAuth<{ url: string }>(
      `/api/organizations/${orgId}/gmail/auth/url`,
      { token }
    );
    return response;
  },

  // Connect new account
  connectAccount: async (orgId: string, code: string, token: string) => {
    const response = await fetchWithAuth<GmailAccountDTO>(
      `/api/organizations/${orgId}/gmail/accounts`,
      {
        method: 'POST',
        body: JSON.stringify({ code }),
        token
      }
    );
    return response;
  },

  // List accounts
  listAccounts: async (orgId: string, token: string) => {
    const response = await fetchWithAuth<GmailAccountDTO[]>(
      `/api/organizations/${orgId}/gmail/accounts`,
      { token }
    );
    return response;
  },

  // Set default account
  setDefaultAccount: async (orgId: string, accountId: string, token: string) => {
    await fetchWithAuth(
      `/api/organizations/${orgId}/gmail/accounts/${accountId}/default`,
      {
        method: 'PUT',
        token
      }
    );
  },

  // Disconnect account
  disconnectAccount: async (orgId: string, accountId: string, token: string) => {
    await fetchWithAuth(
      `/api/organizations/${orgId}/gmail/accounts/${accountId}`,
      {
        method: 'DELETE',
        token
      }
    );
  },

  // Send email
  sendEmail: async (orgId: string, data: {
    from?: string;
    to: string[];
    subject: string;
    body?: string;
    html?: string;
    attachments?: Array<{
      filename: string;
      content: Buffer;
      contentType?: string;
    }>;
  }, token: string) => {
    await fetchWithAuth(
      `/api/organizations/${orgId}/gmail/send`,
      {
        method: 'POST',
        body: JSON.stringify(data),
        token
      }
    );
  }
}; 